import categoriesApi from "@/api/categories";

const state = {
  all: [],
  tree: [],
  category: {},
  rootCategories: []
};

const getters = {
  category: state => state.category,
  categories: state => state.all,
  categoryTree: state => state.tree,
  rootCategories: state => state.rootCategories,
  categoryOptions: state => {
    return state.all.map(c => ({
      text: c.name,
      value: c.id
    }));
  },
  activeCategoryOptions: state => {
    return state.all.filter(c => c.isActive).map(c => ({
      text: c.name,
      value: c.id
    }));
  }
};

const actions = {
  async getAllCategories(context) {
    try {
      const response = await categoriesApi.getCategories();
      context.commit("setCategories", response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCategoryTree(context) {
    try {
      const response = await categoriesApi.getCategoryTree();
      context.commit("setCategoryTree", response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCategory(context, id) {
    try {
      const response = await categoriesApi.getCategory(id);
      context.commit("setCategory", response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getRootCategories(context) {
    try {
      const response = await categoriesApi.getRootCategories();
      context.commit("setRootCategories", response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createCategory(context, category) {
    try {
      const response = await categoriesApi.createCategory(category);
      context.dispatch("getAllCategories"); // Listeyi yenile
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateCategory(context, { id, category }) {
    try {
      const response = await categoriesApi.updateCategory(id, category);
      context.dispatch("getAllCategories"); // Listeyi yenile
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteCategory(context, id) {
    try {
      const response = await categoriesApi.deleteCategory(id);
      context.dispatch("getAllCategories"); // Listeyi yenile
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async checkCategoryKey(context, { categoryKey, excludeId }) {
    try {
      const response = await categoriesApi.checkCategoryKey(categoryKey, excludeId);
      return response.data.exists;
    } catch (error) {
      throw error;
    }
  },

  async checkCategoryName(context, { name, excludeId }) {
    try {
      const response = await categoriesApi.checkCategoryName(name, excludeId);
      return response.data.exists;
    } catch (error) {
      throw error;
    }
  },

  async getMaxSortOrder(context, parentId) {
    try {
      const response = await categoriesApi.getMaxSortOrder(parentId);
      return response.data.maxSortOrder;
    } catch (error) {
      throw error;
    }
  }
};

const mutations = {
  setCategories(state, categories) {
    state.all = categories;
  },

  setCategoryTree(state, tree) {
    state.tree = tree;
  },

  setCategory(state, category) {
    state.category = category;
  },

  setRootCategories(state, categories) {
    state.rootCategories = categories;
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};